import Vue from 'vue'
import Router from 'vue-router'
import { exam } from './exam';
import { system } from './system';
import { datav } from './datav';
import CardRouter from './card' // 题库
import answer from "./answer"; // 新版页面
import auth from "@/v2/utils/auth";
import { baseApi } from '@/v2/utils/api'

const oAuth = r => require(['@/pages/login/oauth'], r)
const SsoLogin = r => require(['@/pages/login/sso'], r)	// sso登录
const TemDownload = r => require(["@/pages/tem/download"], r);
// 作业管理

Vue.use(Router)

const router = new Router({
  linkActiveClass: 'actived',
  linkExactActiveClass: 'actived',
  hashbang: false,
  base: '/region/',
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      redirect: '/sso-login'
    },
    {
      path: "/sso-login",
      component: SsoLogin, // sso登录
      name: "SsoLogin",
      meta: {
        title: '登录'
      }
    },
    {
      path: '/oauth',
      component: oAuth,  // 授权登录页
      name: 'oauth'
    },
    ...CardRouter,
    exam,
    datav,
    system,
    {
      path: "/tem/download",
      name: 'TemDownload',
      component: TemDownload
    },
    answer,
  ]
})

router.beforeEach(async (to, from, next) => {
  if (from.name === 'exam-marking-readPaper') {
    document.body.className = 'logined';
  }
  if (to.meta.title) {
    document.title = 'e卷通-区域-' + to.meta.title
  }
  baseApi.checkBuildVersion()
  if (to.name !== 'SsoLogin' && to.name !== 'oauth') {
    await auth.tryUpdateAuths()
  }
  next()
})

router.afterEach((to, from) => {
  if (window.addIOClick) {
    window.addIOClick()
  }
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js